import { useCallback } from "react";
import { useLocalStorage } from "./useLocalStorage";

export const useIgnoredMRs = () => {
	const [ignoredIds, setIgnoredIds] = useLocalStorage("reviewboard-ignored-mr-ids", []);

	const ignoreMR = useCallback(
		(mrId) => {
			setIgnoredIds((prev) => {
				if (prev.includes(mrId)) return prev;
				return [...prev, mrId];
			});
		},
		[setIgnoredIds],
	);

	const unignoreMR = useCallback(
		(mrId) => {
			setIgnoredIds((prev) => prev.filter((id) => id !== mrId));
		},
		[setIgnoredIds],
	);

	const isIgnored = useCallback(
		(mrId) => {
			return ignoredIds.includes(mrId);
		},
		[ignoredIds],
	);

	return {
		ignoredIds,
		ignoreMR,
		unignoreMR,
		isIgnored,
	};
};
